import { colorsDark, colorsLight } from "@coherehealth/common";
import { QueueViewState } from "@coherehealth/qm-api";
import { makeStyles } from "@material-ui/core";

interface StyleProps {
  drawerWidth?: number;
  queueViewState?: QueueViewState;
}
export const useQmNavigationStyles = makeStyles((theme) => ({
  logoutBtn: {
    height: "36px",
    width: "36px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logoutBtnContainer: {
    borderRadius: "50%",
  },
  navContainer: {
    mr: "1em",
  },
  navItemsContainer: {
    width: (props: StyleProps) => props?.drawerWidth,
    display: "flex",
  },
  navItemContainer: {
    marginBottom: 32,
    width: "100%",
  },
  navLinkTab: {
    minWidth: "4px",
    backgroundColor: colorsDark.primary.main,
    height: "50px",
    mr: "6px",
  },
  icon: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    mr: "6px",
    "&:hover": {
      color: "text.secondary",
    },
  },
  logoutDisplay: {
    color: colorsDark.primary.main,
  },
  buttonContainer: {
    borderRadius: "50%",
  },
  logoutButton: {
    height: "36px",
    width: "36px",
    borderRadius: "50%",
    backgroundColor: colorsLight.primary.faint10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
